module.exports = __webpack_public_path__ + "static/media/Gotham-Book.9019ab71.otf";